import snapshotJson from "./market-snapshot.json";
import weeklyAnalysisJson from "./weekly-analysis.json";
import type { MarketPayload } from "../../shared/market";

export type Preset = "30d" | "90d" | "1y" | "all";

export interface ModelEvent {
  id: string;
  date: string;
  provider: string;
  model: string;
  title: string;
  sourceUrl: string;
  importance: "major" | "notable";
}

export interface WeeklyAnalysis {
  eyebrow: string;
  headline: string;
  summary: string;
  evidence: string[];
  eventReading: string;
  caveat: string;
  generatedAt: string;
}

export interface StaticSnapshot {
  schemaVersion: 1;
  generatedAt: string;
  sourceUpdatedAt: string;
  views: Record<Preset, MarketPayload>;
  analyses: Record<Preset, WeeklyAnalysis>;
  events: ModelEvent[];
}

const marketSnapshot = snapshotJson as Omit<StaticSnapshot, "analyses">;
const weeklyAnalysis = weeklyAnalysisJson as { analyses: Record<Preset, WeeklyAnalysis> };

export const snapshot: StaticSnapshot = { ...marketSnapshot, analyses: weeklyAnalysis.analyses };
